import { View } from 'react-native'
import { useTranslation } from 'react-i18next'
import { ModalBottom } from '@ui/components/Modal'
import Button from '@ui/buttons/Button'

interface Props {
  open: boolean
  onClose: () => void
  onAuthenticate: () => void
  onSkip: () => void
}

export default function ParentAccountFoundModal({
  open,
  onClose,
  onAuthenticate,
  onSkip,
}: Props) {
  const { t } = useTranslation(['modals'])

  return (
    <ModalBottom
      open={open}
      close={onClose}
      title={t('modals:parentAccountFound.title')}
      desc={t('modals:parentAccountFound.desc')}
      spacedText
      body={
        <View className="flex-row items-center gap-8 px-16">
          <Button
            variant="filled"
            label={t('modals:parentAccountFound.authenticate')}
            onPress={onAuthenticate}
          />
          <Button
            variant="outlined"
            label={t('modals:parentAccountFound.skip')}
            onPress={onSkip}
          />
        </View>
      }
    />
  )
}
